import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.check-radio-box-checked {
  background-color: ${dt('checkRadio.checked.background')};
  border-color: ${dt('checkRadio.checked.borderColor')};
}
.check-radio-box-unchecked { border-color: ${dt('checkRadio.unchecked.borderColor')}; }
.check-radio-dot {
  background-color: ${dt('checkRadio.dot.background')};
  color: ${dt('checkRadio.dot.color')};
}
`;
